import { Info } from "lucide-react";
import { AFFILIATE_DISCLOSURE } from "@/data/site";

// Affiliate disclosure — visible, honest, and structured so it can be toggled
// on/off site-wide later. Currently informational (no live affiliate links).
export default function AffiliateDisclosure({ compact = false }) {
  if (compact) {
    return (
      <p className="flex items-start gap-2 text-xs text-forest-950/55 leading-relaxed" data-testid="affiliate-disclosure-compact">
        <Info className="w-3.5 h-3.5 mt-0.5 shrink-0 text-terracotta" />
        {AFFILIATE_DISCLOSURE}
      </p>
    );
  }
  return (
    <div
      className="flex items-start gap-3 rounded-2xl border border-terracotta/20 bg-terracotta/5 px-5 py-4"
      data-testid="affiliate-disclosure"
    >
      <Info className="w-5 h-5 shrink-0 text-terracotta mt-0.5" />
      <p className="text-sm text-forest-950/75 leading-relaxed">
        <span className="font-semibold text-forest-950">A note on recommendations. </span>
        {AFFILIATE_DISCLOSURE}
      </p>
    </div>
  );
}
